"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Link = _interopRequireDefault(require("../Link"));

var _TimerWithPause = _interopRequireDefault(require("../TimerWithPause"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var hideTimer;

var NotificationPopUp = function NotificationPopUp(_ref) {
  var title = _ref.title,
      icon = _ref.icon,
      time = _ref.time,
      description = _ref.description,
      to = _ref.to,
      _ref$hidePopup = _ref.hidePopup,
      hidePopup = _ref$hidePopup === void 0 ? function () {} : _ref$hidePopup,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      className = _ref.className,
      _ref$hideDelay = _ref.hideDelay,
      hideDelay = _ref$hideDelay === void 0 ? 5 : _ref$hideDelay,
      otherProps = _ref.otherProps;

  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  (0, _react.useEffect)(function () {
    setShow(true); // Show the popup default

    hideTimer = new _TimerWithPause.default(function () {
      // After the hideDelay timer is done, start the hide animation
      setShow(false);
      var hidePopUpFunctionTimer = setTimeout(function () {
        // after hide animation return the callback function
        hidePopup();
      }, 500);
    }, hideDelay * 1000);
  }, []);
  return /*#__PURE__*/_react.default.createElement(Container, _extends({
    showPopup: show,
    onMouseEnter: function onMouseEnter() {
      hideTimer.pause();
      setShow(true);
    },
    onMouseLeave: function onMouseLeave() {
      return hideTimer.resume();
    },
    className: className,
    onClick: onClick,
    to: to
  }, otherProps), icon && /*#__PURE__*/_react.default.createElement(IconContainer, null, /*#__PURE__*/_react.default.createElement(IconCircle, null, icon)), /*#__PURE__*/_react.default.createElement(HeaderContentContainer, null, /*#__PURE__*/_react.default.createElement(Title, null, title), /*#__PURE__*/_react.default.createElement(Description, null, description)), /*#__PURE__*/_react.default.createElement(TimeLeft, null, time));
};

var SlideIn = (0, _styledComponents.keyframes)(["0%{right:-100%;opacity:0;}80%{right:5%;opacity:1;}100%{right:0;}"]);
var SlideOut = (0, _styledComponents.keyframes)(["0%{right:0;opacity:1;}100%{opacity:0;right:-100%;}"]);

var TimeLeft = _styledComponents.default.div.withConfig({
  displayName: "TimeLeft"
})(["font-weight:500;font-size:1.4rem;margin-left:2rem;text-align:right;height:100%;flex-shrink:0;color:#8990a3;"]);

var IconCircle = _styledComponents.default.div.withConfig({
  displayName: "IconCircle"
})(["border-radius:50%;padding:0.5rem;width:100%;height:100%;background-color:", ";& > svg{height:100%;width:100%;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.brand.primary;
});

var Container = (0, _styledComponents.default)(function (_ref3) {
  var showPopup = _ref3.showPopup,
      props = _objectWithoutProperties(_ref3, ["showPopup"]);

  return /*#__PURE__*/_react.default.createElement(_Link.default, props);
}).withConfig({
  displayName: "Container"
})(["box-sizing:border-box;display:flex;width:100%;word-break:break-word;margin-bottom:1rem;position:relative;font-family:", ";flex:1 1 100%;max-height:20rem;background:white;border:0.05rem solid #ececec;text-decoration:none;justify-content:space-between;filter:drop-shadow(-0.4rem 0.4rem 1.2rem rgba(0,0,0,0.05));border-radius:0.5rem;opacity:1;cursor:pointer;top:0;right:0;overflow:hidden;padding:2rem;transition:all 500ms ease;z-index:10;animation:", " 500ms forwards ease;", " &:hover{border:0.1rem solid ", ";}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.font;
}, SlideIn, function (_ref5) {
  var showPopup = _ref5.showPopup;
  return !showPopup && (0, _styledComponents.css)(["animation:", " 500ms forwards ease;z-index:9;"], SlideOut);
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.brand.primary;
});

var HeaderContentContainer = _styledComponents.default.div.withConfig({
  displayName: "HeaderContentContainer"
})(["display:flex;flex-direction:column;justify-content:center;flex:1 1 100%;"]);

var IconContainer = _styledComponents.default.div.withConfig({
  displayName: "IconContainer"
})(["margin-right:2rem;height:3.8rem;width:3.8rem;flex:0 0 auto;"]);

var Title = _styledComponents.default.div.withConfig({
  displayName: "Title"
})(["font-style:normal;font-weight:500;font-size:1.6rem;color:#2d2d2d;margin-bottom:0.5rem;"]);

var Description = _styledComponents.default.div.withConfig({
  displayName: "Description"
})(["font-style:normal;font-weight:normal;font-size:1.4rem;color:#8990a3;"]);

NotificationPopUp.propTypes = {
  /** String how long ago the notification happened */
  time: _propTypes.string.isRequired,

  /** Notification description */
  description: _propTypes.string.isRequired,

  /** To url where to go to when clicking on the notification */
  to: _propTypes.string,

  /** Pass an icon as element to be displayed at the front of the bar. */
  icon: _propTypes.element,

  /** Notification title */
  title: _propTypes.string.isRequired,

  /** onClick function when clicked on the notification */
  onClick: _propTypes.func,

  /** Extra classnames to pass to the element. */
  className: _propTypes.string,

  /** Extra props to pass to the element. */
  otherProps: _propTypes.object
};
NotificationPopUp.displayName = 'NotificationPopUp';
var _default = NotificationPopUp;
exports.default = _default;